"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandMenuItems = void 0;
const react_1 = __importStar(require("react"));
const CommandMenuSubMenu_1 = require("../CommandMenuSubMenu/CommandMenuSubMenu");
const getKey_1 = require("../../helpers/getKey");
const removeEdgeSeparator_1 = require("../../helpers/removeEdgeSeparator");
const removeHidden_1 = require("../../helpers/removeHidden");
const Menu_1 = require("../../../Menu");
exports.CommandMenuItems = react_1.default.memo(function CommandMenuItems({ level = 0, menuItems = [], renderContentProps: contentProps, menuItemsRef, handleHide: parentHandleHide }) {
    const otherOpenSubMenuOfThisLevel = (0, react_1.useMemo)(() => {
        return {
            hide: () => { }
        };
    }, []);
    const handleHide = (0, react_1.useCallback)(() => {
        contentProps.actions.hide();
        parentHandleHide === null || parentHandleHide === void 0 ? void 0 : parentHandleHide();
    }, [parentHandleHide, contentProps.actions]);
    const renderContentProps = (0, react_1.useMemo)(() => {
        const actions = Object.assign(Object.assign({}, contentProps.actions), { hide: handleHide });
        return { actions };
    }, [contentProps, handleHide]);
    const totalMenuItems = (0, react_1.useMemo)(() => menuItems.filter(removeHidden_1.removeHidden).filter(removeEdgeSeparator_1.removeEdgeSeparator), [menuItems]);
    if (!totalMenuItems.length) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, totalMenuItems.map((menuItem) => {
        var _a;
        if (menuItem.separator) {
            return (react_1.default.createElement(Menu_1.MenuSeparator, { key: (0, getKey_1.getKey)(menuItem.id || menuItem.text), "data-selector-id": `command-menu-item-${menuItem.id || menuItem.text}` }));
        }
        if ((_a = menuItem.items) === null || _a === void 0 ? void 0 : _a.length) {
            return (react_1.default.createElement(CommandMenuSubMenu_1.CommandMenuSubMenu, { key: (0, getKey_1.getKey)(menuItem.id || menuItem.text), level: level + 1, menuItem: menuItem, menuItemsRef: menuItemsRef, handleHide: handleHide, otherOpenSubMenuOfThisLevel: otherOpenSubMenuOfThisLevel }));
        }
        if (menuItem.renderContent) {
            return (react_1.default.createElement(react_1.default.Fragment, { key: (0, getKey_1.getKey)(menuItem.id) }, menuItem.renderContent(renderContentProps)));
        }
        return (react_1.default.createElement(Menu_1.MenuItem, { key: (0, getKey_1.getKey)(menuItem.id || menuItem.text), "data-selector-id": `command-menu-item-${menuItem.id || menuItem.text}`, isActive: menuItem.isActive, disabled: menuItem.disabled, tooltip: menuItem.tooltip, icon: menuItem.icon, onClick: (e) => {
                var _a;
                e.preventDefault();
                e.stopPropagation();
                handleHide();
                if (!menuItem.disabled) {
                    (_a = menuItem === null || menuItem === void 0 ? void 0 : menuItem.onClick) === null || _a === void 0 ? void 0 : _a.call(menuItem, e);
                }
            } }, menuItem.text));
    })));
});
//# sourceMappingURL=CommandMenuItems.js.map